"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Client = void 0;
var error_1 = require("./error");
var errors = __importStar(require("./error"));
var util_1 = require("./util");
var addresses_1 = require("./resources/addresses");
var postcodes_1 = require("./resources/postcodes");
var keys_1 = require("./resources/keys");
var udprn_1 = require("./resources/udprn");
var umprn_1 = require("./resources/umprn");
var autocomplete_1 = require("./resources/autocomplete");
var Client = /** @class */ (function () {
    function Client(config) {
        this.tls = config.tls;
        this.api_key = config.api_key;
        this.baseUrl = config.baseUrl;
        this.version = config.version;
        this.strictAuthorisation = config.strictAuthorisation;
        this.timeout = config.timeout;
        this.agent = config.agent;
        this.header = __assign(__assign({}, Client.defaults.header), config.header);
        this.postcodes = postcodes_1.create(this);
        this.addresses = addresses_1.create(this);
        this.udprn = udprn_1.create(this);
        this.umprn = umprn_1.create(this);
        this.keys = keys_1.create(this);
        this.autocomplete = autocomplete_1.create(this);
    }
    /**
     * Return base URL for API requests
     */
    Client.prototype.url = function () {
        return this.protocol() + "://" + this.baseUrl + "/" + this.version;
    };
    Client.prototype.protocol = function () {
        return this.tls ? "https" : "http";
    };
    /**
     * Ping API base (`/`)
     *
     * Dispatches HTTP request to root endpoint "`/`"
     */
    Client.prototype.ping = function () {
        var method = "GET";
        var url = this.protocol() + "://" + this.baseUrl + "/";
        return this.agent.http({
            method: method,
            url: url,
            header: {},
            query: {},
            timeout: this.timeout,
        });
    };
    /**
     * Lookup Postcode
     *
     * Search for addresses given a postcode. Postcode queries are case and space insensitive
     *
     * Invalid postcodes return an empty array address result `[]`
     *
     * [API Documentation for /postcodes](https://ideal-postcodes.co.uk/documentation/postcodes#postcode)
     */
    Client.prototype.lookupPostcode = function (options) {
        var queryOptions = this.toAddressIdQuery(options);
        var page = options.page;
        if (page !== undefined)
            queryOptions.query.page = page.toString();
        return this.postcodes
            .retrieve(options.postcode, queryOptions)
            .then(function (response) { return response.body.result; })
            .catch(function (error) {
            if (error instanceof error_1.IdpcPostcodeNotFoundError)
                return [];
            throw error;
        });
    };
    /**
     * Lookup Address
     *
     * Search for an address given a query
     *
     * [API Documentation for /addresses](https://ideal-postcodes.co.uk/documentation/addresses#query)
     */
    Client.prototype.lookupAddress = function (options) {
        var header = {};
        var query = { query: options.query };
        util_1.appendAuthorization({ client: this, header: header, options: options });
        util_1.appendIp({ header: header, options: options });
        util_1.appendFilter({ query: query, options: options });
        util_1.appendTags({ query: query, options: options });
        util_1.appendPage({ query: query, options: options });
        var queryOptions = { header: header, query: query };
        if (options.timeout !== undefined)
            queryOptions.timeout = options.timeout;
        return this.addresses
            .list(queryOptions)
            .then(function (response) { return response.body.result.hits; });
    };
    /**
     * Generates a request object. Bundles together commonly used header/query extractions:
     * - Authorization (api_key, licensee, user_token)
     * - Source IP forwarding
     * - Result filtering
     * - Tagging
     */
    Client.prototype.toAddressIdQuery = function (options) {
        var header = {};
        var query = {};
        util_1.appendAuthorization({ client: this, header: header, options: options });
        util_1.appendIp({ header: header, options: options });
        util_1.appendFilter({ query: query, options: options });
        util_1.appendTags({ query: query, options: options });
        var request = { header: header, query: query };
        if (options.timeout !== undefined)
            request.timeout = options.timeout;
        return request;
    };
    /**
     * Lookup UDPRN
     *
     * Search for an address given a UDPRN
     *
     * Invalid UDPRN returns `null`
     *
     * [API Documentation for /udprn](https://ideal-postcodes.co.uk/documentation/udprn)
     */
    Client.prototype.lookupUdprn = function (options) {
        var queryOptions = this.toAddressIdQuery(options);
        return this.udprn
            .retrieve(options.udprn.toString(), queryOptions)
            .then(function (response) { return response.body.result; })
            .catch(function (error) {
            if (error instanceof error_1.IdpcUdprnNotFoundError)
                return null;
            throw error;
        });
    };
    /**
     * Lookup UMPRN
     *
     * Search for an address given a UDPRN
     *
     * Invalid UDPRN returns `null`
     *
     * [API Documentation for /udprn](https://ideal-postcodes.co.uk/documentation/udprn)
     */
    Client.prototype.lookupUmprn = function (options) {
        var queryOptions = this.toAddressIdQuery(options);
        return this.umprn
            .retrieve(options.umprn.toString(), queryOptions)
            .then(function (response) { return response.body.result; })
            .catch(function (error) {
            if (error instanceof error_1.IdpcUmprnNotFoundError)
                return null;
            throw error;
        });
    };
    /**
     * Check Key Availability
     *
     * Checks if a key can bey used
     *
     * [API Documentation for /keys]()https://ideal-postcodes.co.uk/documentation/keys#key)
     */
    Client.prototype.checkKeyUsability = function (options) {
        var _a = options.api_key, api_key = _a === void 0 ? this.api_key : _a, timeout = options.timeout;
        var licensee = options.licensee;
        var query;
        if (licensee === undefined) {
            query = {};
        }
        else {
            query = { licensee: licensee };
        }
        var queryOptions = { query: query, header: {} };
        if (timeout !== undefined)
            queryOptions.timeout = timeout;
        return this.keys
            .retrieve(api_key, queryOptions)
            .then(function (response) { return response.body.result; }); // Assert that we're retrieving public key information as no user_token provided
    };
    Client.defaults = {
        header: {
            Accept: "application/json",
            "Content-Type": "application/json",
        },
    };
    Client.errors = errors;
    return Client;
}());
exports.Client = Client;
//# sourceMappingURL=client.js.map